import React, { forwardRef } from 'react';
import { isNil, omitBy } from 'lodash';
import { renderChildren } from '@fiverr-private/ui_utils';
import { Stack } from '@fiverr-private/layout_components';
import { FORM_ELEMENT_ID } from '../constants';
import { FormElementProps } from '../types';
import { useFormContext } from '../FormContext';

const FormElement = forwardRef<HTMLInputElement, FormElementProps>(
  ({ children, dataTrackTag = 'form_element', dataTrackValue, ...restProps }, forwardedRef) => {
    const { maxLength, isError, isSuccess, name, ref, onChange, onBlur } = useFormContext();
    const hasRef =
      typeof ref === 'function' || typeof forwardedRef === 'function' || (forwardedRef && 'current' in forwardedRef);

    return (
      <Stack dataTrackTag={dataTrackTag} dataTrackValue={dataTrackValue} direction="column" gap="2">
        {renderChildren(children, {
          ...omitBy(
            {
              maxLength,
              isError,
              isSuccess,
              name,
              ref: hasRef
                ? (e) => {
                    ref?.(e);
                    if (typeof forwardedRef === 'function') {
                      forwardedRef(e);
                    } else if (forwardedRef && 'current' in forwardedRef) {
                      forwardedRef.current = e;
                    }
                  }
                : undefined,
              onChange,
              onBlur,
            },
            isNil
          ),
          ...restProps,
        })}
      </Stack>
    );
  }
);

FormElement.displayName = FORM_ELEMENT_ID;
Object.assign(FormElement, {
  id: FORM_ELEMENT_ID,
});

export default FormElement;
